import React from 'react';
import Header from '../../components/Header';
import ContentBody from '../../components/Content/ContentBody';
    
const Content = () => {
  return (
    <div className="contact-page-black-back">
      <Header PageName="content" fTitle="content" sTitle="" />
      <ContentBody />
    </div>
  );
};

export default Content;
